export default __webpack_public_path__ + "static/media/heart.d56c8735.png";